import React, { Component } from "react";
import { Helmet } from "react-helmet";
import axios from "axios";
import styled from "styled-components";
import { media } from "../../utils/style";
import Headline from "../../components/Headline";
import Description from "../../components/Description";
import ForgotPasswordForm from "../../components/ForgotPasswordForm";
import EmailSent from "../../components/EmailSent";
import EmailError from "../../components/EmailError";

const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  margin: 25px auto 25%;
  max-width: 900px;
  padding: 0 20px;

  ${media.tablet`
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    margin: 100px auto 22%;
  `};
`;

const CustomDescription = styled(Description)`
  margin-top: 30px;
`;

const Copy = styled.div`
  margin: 0 0 30px;
  max-width: 420px;
  padding: 0;

  ${media.phone`
    align-self: center;
  `};

  ${media.tablet`
    align-self: flex-start;
  `};

  ${media.desktop`
    align-self: flex-start;
  `};
`;

const PasswordUtility = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-flow: column nowrap;
  min-height: 400px;

  ${media.tablet`
    width: 100%;
  `};
  ${media.desktop`
    width: 55%;
  `};
`;

class Forgot extends Component {
  constructor() {
    super();
    this.state = {
      hideSuccess: true,
      hideError: true,
      errorMessage: "Error Please Try Again"
    };
  }

  handleSubmit(data, resetForm) {
    const email = data.email;
    axios
      .post(
        `${process.env.REACT_APP_HOST_URL}/users/generate_password_reset_token`,
        {
          email: email
        }
      )
      .then(response => {
        //console.log(response);
        this.setState({
          hideSuccess: false,
          hideError: true
        });
      })
      .catch(error => {
        console.log(error.response);
        if (error.response.status === 403)
          this.setState({
            errorMessage:
              "Password Request has already been sent, please check your inbox"
          });
        this.setState({ hideError: false });
      });
  }

  render() {
    return (
      <div>
        <Helmet>
          <title>Blast - Forgot Password</title>
        </Helmet>

        <Wrapper>
          <Copy>
            <Headline>Forgotten Password?! Blarg!</Headline>
            <CustomDescription>
              Enter the email that you used to create your Blast account.
            </CustomDescription>
          </Copy>
          <PasswordUtility>
            {this.state.hideSuccess && (
              <ForgotPasswordForm handleSubmit={this.handleSubmit.bind(this)} />
            )}
            {!this.state.hideSuccess && <EmailSent />}
            {!this.state.hideError && (
              <EmailError text={this.state.errorMessage} />
            )}
          </PasswordUtility>
        </Wrapper>
      </div>
    );
  }
}

export default Forgot;



// WEBPACK FOOTER //
// ./src/pages/Forgot/index.jsx